<template>
  <div class="page-module">
    <img class="circular1" :src="homeCircular" alt="" />
    <div class="circular2"></div>
    <!-- <div class="circular3"></div> -->
    <div class="swiper-wrapper">
      <div class="swiper-box">
        <el-carousel trigger="click" :interval="6000" arrow="never" height="540px">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index" :style="`background:url(${item.img}) no-repeat center;background-size:100% 100%`">
            <div class="h-100" style="width: 100%; height: 540px" :class="{ pointer: item.open }" @click="clickBanner(item.open)">
              <el-button v-if="item.btnName" class="banner-btn" type="primary">{{ item.btnName }}</el-button>
              <el-button v-if="item.conterBtnName" class="banner-conter-btn" type="primary">{{ item.conterBtnName }}</el-button>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="module-list">
      <div class="special-area-container">
        <ActivityTitle title="数据发送" />
        <div class="transmission">
          <el-row :gutter="12">
            <el-col v-for="(item, index) in modelItems.send" :key="index" :span="8">
              <el-card shadow="hover">
                <div class="grid-content" @click="navToUrl(item.href, item.code)">
                  <div class="grid-logo">
                    <img :src="item.img" alt="" />
                  </div>
                  <div class="grid-contenr">
                    <div class="grid-title">{{ item.title }}</div>
                    <div class="grid-text" v-html="item.text" />
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <ActivityTitle title="运价查询 · 物流跟踪" />
        <div class="track">
          <el-row :gutter="60">
            <el-col v-for="(item, index) in modelItems.track" :key="index" :span="8">
              <el-card shadow="hover">
                <div class="grid-content" @click="navToUrl(item.href, item.code)">
                  <div class="grid-top">
                    <img class="inline-block" :src="item.img" />
                  </div>
                  <div class="grid-botton">
                    <div class="grid-title">{{ item.title }}</div>
                    <div class="grid-text" v-html="item.text" />
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <ActivityTitle title="RPA机器人" />
        <div class="track">
          <el-row :gutter="60">
            <el-col v-for="(v, i) in modelItems.rpa" :key="i" :span="8">
              <el-card shadow="hover">
                <div class="grid-content" @click="toRobot(v.routeName)">
                  <div class="grid-top">
                    <img class="inline-block" :src="v.img" />
                  </div>
                  <div class="grid-botton">
                    <div class="grid-title">{{ v.title }}</div>
                    <div class="grid-text" v-html="v.text" />
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <ActivityTitle title="服务范围" />
        <HomeRelation />
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import { createNamespacedHelpers, mapMutations } from 'vuex'
import { bannerList, modelItems } from './home.js'
import { ossUrl, hasBottomUrls, notNeedCompany } from '@/utils/config.js'
import { getRouterName } from '@/utils/functions'

import ActivityTitle from './components/ActivityTitle.vue'
import HomeRelation from './components/HomeRelation.vue'
const { mapState } = createNamespacedHelpers('user')

export default {
  name: 'HomeIndex',
  components: { ActivityTitle, HomeRelation },
  data() {
    return {
      mes: '',
      bannerList,
      modelItems,
      homeCircular: `${ossUrl}/common/market_v2/home/home-circular-3.png`,
      productArr: [],
      isClient: false
    }
  },
  computed: {
    ...mapState(['isLogin', 'hasCompany', 'openedProducts'])
  },
  mounted() {
    this.isClient = true
  },
  methods: {
    ...mapMutations('user', ['setCurrentTab', 'setCurrentHref']),

    clickBanner(fn) {
      fn && fn()
    },
    //  rpa机器人
    toRobot(name) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      this.$router.push({ name })
    },

    navToUrl(href, code) {
      if (!href) return

      const { notLogin, login } = hasBottomUrls[href]
      const { isLogin, hasCompany, openedProducts } = this

      if (!isLogin) {
        this.toUrlAndScrollTop(notLogin)
        return
      }
      // 不需要认证企业
      const noCompany = notNeedCompany.includes(href)

      if (!noCompany && !hasCompany) {
        this.toUrlAndScrollTop(notLogin)
        return
      }

      if (!noCompany && code && openedProducts[code] !== '已开通') {
        this.toUrlAndScrollTop(notLogin)
        return
      }

      this.toUrlAndScrollTop(login || href)
    },

    // 跳转页面并滚动只顶部
    toUrlAndScrollTop(href) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      router.push(href)
      let timer
      timer = setTimeout(() => {
        let path = location.pathname
        this.setCurrentTab(getRouterName(path))
        this.setCurrentHref(href)
        clearTimeout(timer)
      }, 20)
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-text {
  height: 28px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin: 32px 0 16px 0;
}
.dialog-desc {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  margin-bottom: 32px;
}
.dialog-btn {
  width: 260px;
  height: 32px;
  background: #1677ff;
  border-radius: 4px;
  line-height: 0px;
}

::v-deep.el-card {
  border: none !important;
  .el-card__body {
    padding: 0;
  }
}

.page-module {
  position: relative;
  overflow: hidden;
  background: #f0f3fb;
  .circular1 {
    width: 420px;
    position: absolute;
    top: -60px;
    left: 50%;
    transform: translateX(-680px);
  }
  .circular2 {
    position: absolute;
    top: 320px;
    left: 50%;
    transform: translateX(300px);
    width: 880px;
    height: 880px;
    border-radius: 50%;
    background-color: #d8e5fa;
    opacity: 50%;
  }
  .circular3 {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-1200px);
    width: 550px;
    height: 550px;
    border-radius: 50%;
    background-color: #d8e5fa;
    opacity: 50%;
  }
}

.transmission {
  width: 1200px;
  margin: 0 auto;

  ::v-deep .el-col {
    margin-bottom: 12px;
  }
  .grid-content {
    height: 144px;
    background-color: white;
    display: flex;
    align-items: center;
    cursor: pointer;
    .grid-logo {
      width: 144px;
      display: flex;
      justify-content: center;
      align-items: center;
      & > img {
        display: inline-block;
        width: 64px;
        height: 64px;
      }
    }
    .grid-contenr {
      flex: 1;
      .grid-title {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
      }
      .grid-text {
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        padding-top: 10px;
      }
    }
  }
  .el-row {
    margin-bottom: 12px;
  }
}

.track {
  width: 1200px;
  margin: 0 auto;
  .grid-content {
    height: 445px;
    background-color: white;
    cursor: pointer;
    .grid-top {
      width: 100%;
      height: 60%;
      text-align: center;
      img {
        height: 100%;
      }
    }
    .grid-botton {
      text-align: center;
      background-color: #e1eeff;
      height: 40%;

      .grid-title {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        padding: 33px 0 20px;
      }
      .grid-text {
        font-weight: 400;
        color: #333333;
        font-size: 18px;
        padding: 0 30px;
        line-height: 30px;
      }
    }
  }
}

.swiper-wrapper {
  padding-top: 40px;

  .swiper-box {
    width: 1200px;
    height: 540px;
    margin: 0 auto;
    box-shadow: 0px 10px 50px 4px rgba(201, 213, 255, 0.52);
    border-radius: 39px;
    overflow: hidden;
    background-color: white;
    .banner-btn {
      position: absolute;
      left: 117px;
      bottom: 135px;
      background-color: #1170eb;
      border-color: #1170eb;
      padding: 0;
      box-shadow: 0px 0px 8px 0px rgba(17, 112, 235, 0.3);
      border-radius: 4px;
      width: 112px;
      height: 32px;
      line-height: 30px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }

    .banner-conter-btn {
      position: absolute;
      left: 50%;
      top: 241px;
      margin-left: -56px;
      border-color: #ffffff;
      background-color: #ffffff !important;
      padding: 0;
      width: 112px;
      height: 38px;
      line-height: 30px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #1170eb;
      font-weight: 600;
      box-shadow: 0px 0px 7px 0px rgba(17, 112, 235, 0.44);
      border-radius: 4px;
    }
  }
}

::v-deep.el-carousel {
  .is-active button {
    background-color: #1170eb !important;
  }
  .el-carousel__indicator {
    padding: 33px 8px;
    .el-carousel__button {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #d8d8d8;
    }
  }
}

.module-slogan {
  width: 100%;
  height: 236px;
  text-align: center;
  background: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home_module_slogan.png');
  .slogan {
    font-size: 24px;
    font-weight: 500;
    font-size: 36px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    color: #ffffff;
  }
}
</style>
